import { createApolloPluginClient } from 'nuxt-base/apollo/apolloClient.client'

export default defineNuxtPlugin(() => {
  return createApolloPluginClient((i) => useApollo(i === 'post' ? 'post' : 'get'))()
})
